exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.i(require("-!../../../../../node_modules/css-loader/dist/cjs.js??ref--9-1!../../../../../node_modules/sass-loader/dist/cjs.js!../clickable.css"), "");

// Module
exports.push([module.id, ".clickable-root .icon-container .icon{background-color:unset !important;border:2px solid rgba(255,254,254,.2) !important}.navTrigger-module-root{height:3rem;width:3rem}", ""]);

// Exports
exports.locals = {
	"root": "navTrigger-module-root " + require("-!../../../../../node_modules/css-loader/dist/cjs.js??ref--9-1!../../../../../node_modules/sass-loader/dist/cjs.js!../clickable.css").locals["root"] + ""
};